import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';
import { updateModule } from 'owa-app-module-store';
import { orchestrator } from 'satcheljs';
import { Module } from 'owa-workloads-module';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "LoopNav" */ './lazyIndex'),
    {
        name: 'LoopNav',
    }
);

export const lazyFocusNextEvent: LazyAction<typeof lazyIndex.focusNextEvent, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.focusNextEvent);
export const lazyInitNotModuleNavigationLoopNav: LazyAction<
    typeof lazyIndex.initChildWindowNavigationLoopNav,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initChildWindowNavigationLoopNav);
export const lazyFocusNextElement: LazyAction<
    typeof lazyIndex.ModuleNavigationManager.focusNextElement,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ModuleNavigationManager.focusNextElement);
export const lazySetAppSections: LazyAction<
    typeof lazyIndex.ModuleNavigationManager.initAppSections,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ModuleNavigationManager.initAppSections);
export const lazyOnKeyDownEvent: LazyAction<typeof lazyIndex.onKeyDownEvent, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onKeyDownEvent);
export const lazyArrangeCalendarSections: LazyAction<
    typeof lazyIndex.arrangeCalendarSections,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.arrangeCalendarSections);
export const lazyIsFocusingElement: LazyAction<
    typeof lazyIndex.ModuleNavigationManager.isFocusingElement,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ModuleNavigationManager.isFocusingElement);
export const lazyFocusSection: LazyAction<
    typeof lazyIndex.ModuleNavigationManager.focusSection,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ModuleNavigationManager.focusSection);
export const lazySetContainerInSection: LazyAction<
    typeof lazyIndex.ModuleNavigationManager.setContainerInSection,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ModuleNavigationManager.setContainerInSection);
export const lazySetContainerInSectionChildWindow: LazyAction<
    typeof lazyIndex.setContainerInSectionChildWindow,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setContainerInSectionChildWindow);

export type { default as NavigationManager } from './NavigationManager';

const lazyGetModuleManagerInstance: LazyAction<
    typeof lazyIndex.ModuleNavigationManager.getInstance,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ModuleNavigationManager.getInstance);
orchestrator(updateModule, actionMessage => {
    const { currentModule, newModule } = actionMessage;

    // When the module is changing to a module not supported
    // Dispose all sections to prevent memory leaks.
    if (currentModule && !isModuleSupported(newModule)) {
        lazyGetModuleManagerInstance.importAndExecute().then(instance => {
            instance.disposeSections();
        });
    }
});

const isModuleSupported = (newModule: Module) => {
    return (
        newModule == Module.Mail ||
        newModule == Module.Calendar ||
        newModule == Module.People ||
        newModule == Module.PeopleNew
    );
};
